import { startMsalApp } from '@higgins/ui';
import App from './app';
import { msalInstance, API_SCOPES } from './lib/msal';
import './index.css';

// Keep a copy of the portal on the device, so the "Higgins Apps" home-screen
// icon opens with no signal and reaches apps that work offline (#391).
// Built app only — `vite` dev serves no sw.js.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch((err) => console.error('[sw]', err));
}

// The portal gets no login_hint: run as the account last used here, else ask (#313).
void startMsalApp({ msal: msalInstance, scopes: API_SCOPES, app: <App /> });
